<script setup>
import traiteurPopin5 from "@/assets/images/traiteur/traiteur-permanent/illustration/popin-ccm/traiteur-popin-5.svg";
import traiteurPopin4 from "@/assets/images/traiteur/traiteur-permanent/illustration/popin-ccm/traiteur-popin-4.svg";
import traiteurPopin3 from "@/assets/images/traiteur/traiteur-permanent/illustration/popin-ccm/traiteur-popin-3.svg";
import traiteurPopin2 from "@/assets/images/traiteur/traiteur-permanent/illustration/popin-ccm/traiteur-popin-2.svg";
import traiteurPopin1 from "@/assets/images/traiteur/traiteur-permanent/illustration/popin-ccm/traiteur-popin-1.svg";
defineEmits(["closed"]);
</script>
<script>
import Popin from "@/components/molecules/popin";
import Icon from "@/components/atoms/icon";
import Button from "@/components/atoms/button";
import Badge from "@/components/atoms/badge";
import Divider from "@/components/atoms/divider";
import Titre from "@/components/atoms/titre";
import LazyImage from "@/components/atoms/lazy-image";
import GridRow from "@/components/molecules/grid/grid-row";
import GridCol from "@/components/molecules/grid/grid-col";
import Container from "@/components/atoms/container";

export default {
  name: "PopinTraiteurPermanent",
  components: {
    Popin,
    Icon,
    Button,
    Badge,
    Titre,
    LazyImage,
    Divider,
    GridRow,
    GridCol,
    Container
  },
  props: {
    traiteurPermanentCategorySlug: {
      type: String,
      required: true
    }
  },
  data() {
    return {};
  },
  methods: {
    isSameRoute(path) {
      const {
        currentRoute: { fullPath: curPath }
      } = this.$router;
      return curPath === path;
    },
    handleClick() {
      this.$refs.popin.hide();
      if (this.traiteurPermanentCategorySlug) {
        if (this.isSameRoute(this.traiteurPermanentCategorySlug)) {
          this.$router.go();
        }
        navigateToInternal(this.traiteurPermanentCategorySlug);
      }
    }
  }
};
</script>

<template>
  <Popin
    ref="popin"
    size="lg"
    aria-label="Traiteur permanent"
    v-bind="removeClassAndStyleFromAttrs($attrs)"
    @closed="$emit('closed')"
  >
    <Container size="xs">
      <div class="u-text-center u-font-16 u-mb-xlg">
        <Badge
          circle
          variant="traiteur"
          size="xxxlg"
          class="u-mb-xs25"
        >
          <Icon
            variant="white"
            name="traiteur-permanent"
            size="lg"
          />
        </Badge>

        <Titre
          tag="h1"
          variant="primary"
          class="u-mb-xs25"
        >
          Optez pour un bon moment avec les produits Traiteur sur commande !
        </Titre>
        <p class="u-font-16 u-mb-xlg">
          Vous recevez ? Vous êtes invité et vous ne savez pas quoi apporter ?
          <br><br>
          Commandez vos produits traiteur sur commande fraîchement composés pour vous<br>
          et retirez-les en magasin sous 4 jours ouvrés
        </p>
        <GridRow class="u-flex-align-center u-flex-column-reverse@sm">
          <GridCol sm="12">
            <LazyImage
              :src="traiteurPopin1"
              width="250"
              class="u-flex-item-none"
            />
          </GridCol>
          <GridCol
            sm="12"
            class="u-mb-sm@sm"
          >
            <div class="u-flex">
              <Badge
                circle
                size="lg"
                variant="primary"
                class="u-mr-xs25 u-flex-shrink-none"
              >
                <strong class="u-font-secondary u-font-20">1</strong>
              </Badge>
              <div class="u-text-left">
                <Titre
                  tag="h2"
                  size="md"
                  variant="primary"
                >
                  Je choisis le(s) produit(s) traiteur de mon choix
                </Titre>
                <p class="u-mt-xxs">
                  en fonction du nombre de personnes, sur le site Cora.fr
                </p>
              </div>
            </div>
          </GridCol>
        </GridRow>

        <Divider
          dotted
          class="u-my-lg"
        />

        <GridRow class="u-flex-align-center">
          <GridCol
            sm="12"
            class="u-mb-sm@sm"
          >
            <div class="u-flex">
              <Badge
                circle
                size="lg"
                variant="primary"
                class="u-mr-xs25 u-flex-shrink-none"
              >
                <strong class="u-font-secondary u-font-20">2</strong>
              </Badge>
              <div class="u-text-left">
                <Titre
                  tag="h2"
                  size="md"
                  variant="primary"
                >
                  Je programme mon retrait de commande
                </Titre>
                <p class="u-mt-xxs">
                  le jour qui me convient le mieux.
                </p>
              </div>
            </div>
          </GridCol>
          <GridCol sm="12">
            <LazyImage
              :src="traiteurPopin2"
              width="250"
              class="u-flex-item-none"
            />
          </GridCol>
        </GridRow>

        <Divider
          dotted
          class="u-my-lg"
        />

        <GridRow class="u-flex-align-center u-flex-column-reverse@sm">
          <GridCol sm="12">
            <LazyImage
              :src="traiteurPopin3"
              width="250"
              class="u-flex-item-none"
            />
          </GridCol>
          <GridCol
            sm="12"
            class="u-mb-sm@sm"
          >
            <div class="u-flex">
              <Badge
                circle
                size="lg"
                variant="primary"
                class="u-mr-xs25 u-flex-shrink-none"
              >
                <strong class="u-font-secondary u-font-20">3</strong>
              </Badge>
              <div class="u-text-left">
                <Titre
                  tag="h2"
                  size="md"
                  variant="primary"
                >
                  Je règle ma commande
                </Titre>
                <p class="u-mt-xxs">
                  en quelques clics, sur Cora.fr
                </p>
              </div>
            </div>
          </GridCol>
        </GridRow>

        <Divider
          dotted
          class="u-my-lg"
        />

        <GridRow class="u-flex-align-center u-mb-xlg">
          <GridCol
            sm="12"
            class="u-mb-sm@sm"
          >
            <div class="u-flex">
              <Badge
                circle
                size="lg"
                variant="primary"
                class="u-mr-xs25 u-flex-shrink-none"
              >
                <strong class="u-font-secondary u-font-20">4</strong>
              </Badge>
              <div class="u-text-left">
                <Titre
                  tag="h2"
                  size="md"
                  variant="primary"
                >
                  Je récupère ma commande
                </Titre>
                <p class="u-mt-xxs">
                  au moment prévu.
                </p>
              </div>
            </div>
          </GridCol>
          <GridCol sm="12">
            <LazyImage
              :src="traiteurPopin4"
              width="250"
              class="u-flex-item-none"
            />
          </GridCol>
        </GridRow>

        <Button
          variant="secondary"
          radius="full"
          size="md"
          @click="handleClick()"
        >
          Voir la sélection Traiteur sur commande
        </Button>

        <div class="u-mt-xlg">
          <LazyImage
            :src="traiteurPopin5"
            width="280"
            class="u-flex-item-none"
          />
        </div>
      </div>
    </Container>
  </Popin>
</template>

<style lang="scss" scoped>
</style>
